// extracted by mini-css-extract-plugin
export default {"root":"SignInHeader_root__DUMKv","right":"SignInHeader_right__SseGe","top":"SignInHeader_top__nJMOT"};